import React, { useState } from 'react';
import { ChevronDown, ChevronUp, Check } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { suitesData } from '../data/suitesData';
import './SuitesSection.css';

const SuitesSection = () => {
  const [expandedSuite, setExpandedSuite] = useState(null);

  const toggleSuite = (suiteId) => {
    setExpandedSuite(expandedSuite === suiteId ? null : suiteId);
  };

  return (
    <section className="suites-section">
      <div className="container">
        <h2 className="section-title text-center">The World's Finest Suites At Sea</h2>
        <p className="section-subtitle text-center">
          Every accommodation aboard Explora Journeys is a spacious oceanfront suite with a private terrace.
          From elegant Ocean Terrace Suites to the spectacular Owner's Residence, discover your sanctuary at sea.
        </p>

        <div className="suites-grid">
          {suitesData.map((suite) => (
            <Card key={suite.id} className={`suite-card ${expandedSuite === suite.id ? 'expanded' : ''}`}>
              <div className="suite-image-container">
                <img src={suite.image} alt={suite.name} className="suite-image" loading="lazy" />
                <div className="suite-image-overlay">
                  <h3 className="suite-name-overlay">{suite.name}</h3>
                  <p className="suite-tagline-overlay">{suite.tagline}</p>
                </div>
              </div>
              
              <CardContent className="suite-content">
                <div className="suite-header-info">
                  <div className="suite-size-info">
                    <div className="size-item">
                      <span className="size-label">Suite Size</span>
                      <span className="size-value">{suite.size}</span>
                    </div>
                    <div className="size-item">
                      <span className="size-label">Terrace</span>
                      <span className="size-value">{suite.terraceSize}</span>
                    </div>
                  </div>
                  <div className="occupancy-info">
                    <span className="occupancy-label">Occupancy:</span>
                    <span className="occupancy-value">{suite.occupancy}</span>
                  </div>
                </div>

                <button 
                  className="suite-toggle-btn"
                  onClick={() => toggleSuite(suite.id)}
                >
                  {expandedSuite === suite.id ? (
                    <>
                      <span>Show Less</span>
                      <ChevronUp className="toggle-icon" />
                    </>
                  ) : (
                    <>
                      <span>View Details</span>
                      <ChevronDown className="toggle-icon" />
                    </>
                  )}
                </button>

                {expandedSuite === suite.id && (
                  <div className="suite-details">
                    <div className="details-section">
                      <h4 className="details-title">Suite Features</h4>
                      <ul className="features-list">
                        {suite.features.map((feature, index) => (
                          <li key={index} className="feature-item">
                            <Check className="feature-check" />
                            <span>{feature}</span>
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className="details-section">
                      <h4 className="details-title">Exclusive Services</h4>
                      <ul className="features-list">
                        {suite.services.map((service, index) => (
                          <li key={index} className="feature-item">
                            <Check className="feature-check" />
                            <span>{service}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SuitesSection;
